<template>
  <div id="app" class="cur">
    <div id="mainContainer">
      <keep-alive include="settle,success">
        <router-view :key="$route.fullPath"></router-view>
      </keep-alive>
    </div>
  </div>
</template>

<script>
// import {mapMuation } from 'vuex';
import { mapMutations, mapState } from "vuex";
import { get_shopinfoApi } from "@/api";
export default {
  data() {
    return {
      xiang: null,
    };
  },
  computed: {
    ...mapState(["admin_id", "baseUrl", "lang"]),
  },
  watch: {
    $route: {
      handler: function (val, oldVal) {
        const that = this;
        console.log("路由", val);
        if (
          val.fullPath.substring(0, 9) == "/personal" ||
          val.fullPath.substring(0, 11) == "/product?id"
        ) {
          localStorage.setItem("show", false);
        } else {
          localStorage.setItem("show", true);
        }
        console.log("路由", val.query);
        if (val.path == "/home") {
          if (val.query.admin_id) {
            const id = val.query.admin_id;
            if (id != this.admin_id) {
              id = this.admin_id;
            }
            // console.log("id", id);
            this.$router.push({
              path: "/home",
              query: {
                admin_id: this.admin_id,
                lang: val.query.lang,
                lange: val.query.lange,
              },
            });
            this.changeAdmin_id(Number(id));
            // console.log(this.admin_id);
            // console.log(1);
          } else {
            this.$router.push({
              path: "/home",
              query: {
                lang: val.query.lang || 0,
                lange: val.query.lange || "zh",
              },
            });
            this.changeAdmin_id(0);
            // console.log(2);
          }
        } else {
          this.changeSort(false);
        }
      },
      // 深度观察监听
      deep: true,
    },
  },
  mounted() {
    this.getxiang();
    var that = this;
    setTimeout(function () {
      console.log("app", that.xiang);
      document.title = that.xiang.lang.title;
      const link = document.getElementsByTagName("link")[0];
      // console.log(link);
      link.href = that.baseUrl + that.xiang.min_logo;

      that.setXiang(that.xiang);
    }, 500);
  },

  methods: {
    ...mapMutations(["changeAdmin_id", "changeSort", "setXiang"]),
    async getxiang() {
      // console.log(123)
      const { data: res } = await get_shopinfoApi({
        lang: this.lang,
        admin_id: this.admin_id,
      });

      this.xiang = res.data;
      console.log("shang", this.xiang);
    },
  },
};
</script>
<style lang="less">
html,
body {
  min-width: 1024px;
  max-width: 1920px;
  // overflow-x: hidden;
}
#app {
  height: 100%;
  // height: 1080px;
  // width: 1920px;
  // position: relative;
  position: absolute;
  left: 0px;
  right: 0px;
  margin: 0 auto;
  // margin: 0 auto;
  #mainContainer {
    height: 100%;
    // position: absolute;
    // left: 0px;
    // right: 0px;
    // margin: 0 auto;
  }
}
@media screen and(max-width:750px) {
  #app {
    width: auto;
  }
  html,
  body {
    min-width: auto;
    max-width: auto;
  }
}
</style>
